import React from 'react';
import ReactDOM from 'react-dom/client';
import '@/styles/globals.css';
import App from '@/App';

// HTML5 Drag and Drop polyfill for touch devices (iPad, tablets)
import { polyfill } from 'mobile-drag-drop';
import 'mobile-drag-drop/default.css';

polyfill({
  dragImageTranslateOverride: (scrollLeft, scrollTop, _el) => {
    return {
      x: scrollLeft,
      y: scrollTop,
    };
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
